import { FeatureModelType } from '@teinor/erp/types/company/product/feature'
import { TwinDictionary } from '../../globals/dictionary'

interface Feature {
    id: number
    name: string
    values: { [FeatureValueId: string]: string }
}
export type Features = { [FeatureId: string]: Feature }

export interface FeaturesAction {
    type: 'CHANGE_FEATURES'
    payload: FeatureModelType[]
}

export type FeaturesPayload = Features | null

export default function features(state: FeaturesPayload = null, action: FeaturesAction): Features | null {
    switch (action.type) {
        case 'CHANGE_FEATURES':
            let result: TwinDictionary = {}
            const myFeatures = action.payload
            if (myFeatures) {
                for (let item of myFeatures) {
                    const featuresVals: { [id: string]: any } = {}
                    if (item.FeatureValues) {
                        for (let fval of item.FeatureValues) {
                            featuresVals[fval.id] = { name: fval.FeatureValueLangs?.[0].name }
                        }
                    }
                    result[item.id] = {
                        id: item.id,
                        name: item.FeatureLangs?.[0].name,
                        values: featuresVals
                    }
                }
            }
            return state = result
        default:
            return state
    }
}